import { useContext } from 'react';
import { ElContext } from '../store/context';

export const useTargetEls = () => useContext(ElContext)?.[0];
